// @flow

import React from 'react';
import Relay from 'react-relay/classic';

import FriendlyTime from 'app/components/shared/FriendlyTime';

import { Section, SectionHeading } from './shared';

type Props = {
  auditEvent: {
    uuid: string,
    type: string,
    occurredAt: string,
    data?: string
  }
};

class AuditLogEventSection extends React.PureComponent<Props> {
  render() {
    const { auditEvent } = this.props;

    return (
      <Section>
        <SectionHeading className="m0 mb2">
          Event
        </SectionHeading>
        <dl className="m0">
          <dt className="mt1 dark-gray">
            Event Timestamp
          </dt>
          <dd className="ml0">
            <FriendlyTime value={auditEvent.occurredAt} />
          </dd>
          <dt className="mt1 dark-gray">
            Event UUID
          </dt>
          <dd className="ml0 monospace">
            {auditEvent.uuid}
          </dd>
          <dt className="mt1 dark-gray">
            Event Type
          </dt>
          <dd className="ml0 monospace">
            {auditEvent.type}
          </dd>
          {this.renderEventData(auditEvent.data)}
        </dl>
      </Section>
    );
  }

  renderEventData(data) {
    // Only render event data if there is any data
    if (data && data !== "{}") {
      const prettyData = JSON.stringify(JSON.parse(data), null, '  ');

      return [
        <dt className="mt1 dark-gray" key="data-title">
          Event Data
        </dt>,
        <dd className="ml0" key="data-definition">
          <pre className="code">{prettyData}</pre>
        </dd>
      ];
    }
  }
}

export default Relay.createContainer(AuditLogEventSection, {
  initialVariables: {
    hasExpanded: false
  },

  fragments: {
    auditEvent: () => Relay.QL`
      fragment on AuditEvent {
        uuid
        type
        occurredAt
        data @include(if: $hasExpanded)
      }
    `
  }
});
